<template>
  <div>
    <el-descriptions
      border
      size="small"
      :labelStyle="{ width: '100px' }"
      :column="2"
    >
      <el-descriptions-item
        :label="$l('INDEX.prod_form_masterNcNo') || '成品编码'"
      >
        {{ goodsInfo.masterNcNo || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_ncNo') || '子件编码'"
        v-if="this.type != 'package'"
      >
        {{ goodsInfo.ncNo || '--' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      border
      size="small"
      class="bottom-desc"
      :labelStyle="{ width: '100px' }"
      :column="2"
    >
      <el-descriptions-item
        :label="$l('INDEX.prod_form_goodsName') || '产品名称'"
      >
        {{ goodsInfo.goodsName || '--' }}
      </el-descriptions-item>
    </el-descriptions>
    <el-descriptions
      border
      size="small"
      class="bottom-desc"
      :labelStyle="{ width: '100px' }"
      :column="2"
    >
      <el-descriptions-item
        :label="$l('INDEX.prod_form_spec') || '产品尺寸'"
      >
        {{ goodsInfo.spec || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_goodsColor') || '产品颜色'"
      >
        {{ goodsInfo.goodsColor || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_factoryOrderNo') || '工厂订单号'"
      >
        {{ goodsInfo.factoryOrderNo || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_authorByName') || '业务员'"
      >
        {{ goodsInfo.authorByName || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_qty') || '子件数量'"
      >
        {{ goodsInfo.qty || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_reportedWorkQty') || '报工数量'"
        v-if="this.type != 'quality'"
      >
        {{ goodsInfo.reportedWorkQty || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_quality') || '良品数量'"
        v-if="this.type == 'quality'"
      >
        {{ goodsInfo.passQty || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_surplusQty') || '剩余数量'"
      >
        {{
          (this.type == 'quality'
            ? goodsInfo.surplusQty
            : goodsInfo.workLogSurplusQty) || '--'
        }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_custName') || '订单客户'"
      >
        {{ goodsInfo.custName || '--' }}
      </el-descriptions-item>
      <el-descriptions-item
        :label="$l('INDEX.prod_form_custOrderNo') || '客户订单号'"
      >
        <div
          style="display: flex;justify-items: center; justify-content: space-between; align-items: center;"
        >
          <div>{{ goodsInfo.custOrderNo || '--' }}</div>
          <b-button
            v-if="!disabled"
            size="sm"
            variant="outline-success"
            @click="openChooseGoods()"
            >{{ $l('INDEX.prod_form_button_masterNcNo') || '更换产品' }}
          </b-button>
        </div>
      </el-descriptions-item>
    </el-descriptions>
    <ChooseGoods
      :visible.sync="goodsDialogVisible"
      :pendingGoodsCode="pendingGoodsCode"
      :changeCodeList="changeCodeList"
      :chooseType="type"
      :title="$l('INDEX.prod_form_chooseGoods_title') || '产品信息'"
      :height="550"
      @confirm="goodConfirm"
      type="radio"
    />
  </div>
</template>
<script>
import ChooseGoods from '../choose-goods/dialog.vue'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: {
    ChooseGoods,
  },
  mixins: [EditLoading],
  props: {
    changeCodeList: { type: Array, default: () => [] },
    type: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      goodsInfo: {},
      goodsDialogVisible: false,
      pendingGoodsCode: '',
    }
  },
  methods: {
    async getData(pendingGoodsCode) {
      this.pendingGoodsCode = pendingGoodsCode
      this.$api.pendingGoodsDetailApi(this.pendingGoodsCode).then((res) => {
        this.goodsInfo = res.body
      })
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
    openChooseGoods() {
      this.goodsDialogVisible = true
    },
    async goodConfirm(goodConfirm) {
      const { masterNcNo, ncNo, pendingGoodsCode } = goodConfirm
      const confirm = await this.$confirm(
        `是否确认更换产品[${masterNcNo}   ${ncNo ? '-' + ncNo : ''}]?`,
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      if (this.loadingOpen()) return
      let saveApi = {}
      switch (this.type) {
        case 'quality':
          saveApi = this.$api.pendingGoodsQualityChangeGoodsApi
          break
        case 'workLog':
          saveApi = this.$api.pendingGoodsWorkLogChangeGoodsApi
          break
        case 'package':
          saveApi = this.$api.pendingGoodsPackageWorkLogChangeGoodsApi
          break
        default:
          throw new Error('类型错误')
      }

      const res = await saveApi({
        pendingGoodsCode,
        changeCodeList: this.changeCodeList,
      }).catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error('更换失败！')
        return
      }
      this.$message({
        message: '更换成功！',
        type: 'success',
      })
      this.$emit('changeGoods')
      this.goodsDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep {
  .bottom-desc {
    .el-descriptions-item__label,
    .el-descriptions-item__content {
      border-top: none !important;
    }
  }
}
</style>
